import Logout from './Logout-Container';

export default Logout;
